var _rect, _path, _circle, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndusSystemRouterFleetcoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 26,
    fill: "#EAF5FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 30h42l16 17v18H66M20 30v35h12M43 65h12",
    stroke: "#287EB7",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 65,
    r: 9,
    stroke: "#287EB7",
    strokeWidth: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 65,
    r: 9,
    stroke: "#287EB7",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 34v15h13",
    stroke: "#287EB7",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndusSystemRouterFleetcoreIcon);
export default __webpack_public_path__ + "static/media/andus-system-router-fleetcore-icon.f28ae85846f9965f8103674b2f0e85a7.svg";
export { ForwardRef as ReactComponent };